var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BorrarModalComponent',{attrs:{"name":'borrar-' + _vm.liquidacion.id,"title":"Borrar liquidación","confirmButton":"¿BORRAR  LIQUIDACIÓN?"},on:{"close":() => _vm.close(false),"confirm":() => _vm.borrarLiquidacion()}})
}
var staticRenderFns = []

export { render, staticRenderFns }